import styles from '../../styles/contato.module.css';

export function BackButton({
  ...rest
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <div className="d-flex flex-column align-items-center text-center mt-4">
      <button className={styles.backButton} {...rest}>
        Voltar
      </button>
    </div>
  );
}
